import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { SymbolButton } from "../SymbolButton/SymbolButton";

export class CopyButton extends BaseComponent<ICopyButtonProps, ICopyButtonState>
{
    private copyTimeout?: NodeJS.Timeout;

    constructor(props: ICopyButtonProps)
    {
        super(props);
        this.state = { copied: false };
    }

    public componentWillUnmount(): void
    {
        clearTimeout(this.copyTimeout);
    }

    private async handleClick(): Promise<void>
    {
        try
        {
            const text = this.props.onClick();
            await navigator.clipboard.writeText(text);

            clearTimeout(this.copyTimeout);
            this.setState({ copied: true });
            this.copyTimeout = setTimeout(() => this.setState({ copied: false }), 2000);
        }
        catch
        {
        }
    }

    public render(): JSX.Element
    {
        return (
            <SymbolButton
                name={this.state.copied ? 'check' : 'copy'}
                onClick={() => this.handleClick()}
            />
        );
    }
}

export interface ICopyButtonProps
{
    onClick: () => string;
}

export interface ICopyButtonState
{
    copied: boolean;
}
